import { clickTrack, redirectToNewTab} from "../../utils/common";
import StyledButton from "../../styles/StyledCDButton";
import { useState } from "react";


export const OpenNowWrapper = ({ openConfirmationModal }) => {
  const [loading, setLoading] = useState(false);
  return (
    <div className="open-now-wrapper d-flex">
        <StyledButton
          variant="light"
          className="mt-1 text-center open option fs-14 font-semi-bold"
          onClick={(e) => openConfirmationModal(e,setLoading)}
          onMouseDown={(e) => e.preventDefault()}
        >
          {loading ? (
            <div className="button-spinner" />
          ) : (
            "Open Now"
          )}
        </StyledButton>
    </div>
  );
};

export async function redirectToLoader(Apply, setLoading) {
  setLoading(true);
  try {
    const url = Apply?.openNowUrl ? Apply?.openNowUrl : Apply?.actionUrl;
    const res = await clickTrack(Apply, url, true);
    const redirect = res?.data?.redirectUrl;
    if (redirect) redirectToNewTab(redirect);
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
}
